import { useMagicLink, useSession } from "@otto/plattform";
import styles from "../../../shared/components/shell.module.css";

export function SignIn() {
  const { client } = useSession();
  const { email, setEmail, status, submit, blocked } = useMagicLink(client);

  return (
    <div className={styles.centered}>
      <div className={styles.signInCard}>
        <h1 className={styles.title}>Otto tippt los</h1>
        <p className={styles.subtitle}>Anmeldung für Lehrkräfte und Schulleitung.</p>

        {status.kind === "sent" ? (
          <div className={`${styles.notice} ${styles.noticeGood}`}>
            Wir haben Ihnen einen Anmeldelink an <strong>{email}</strong> geschickt. Der
            Link gilt für eine Stunde. Sie können dieses Fenster offen lassen.
            {/* Der Hinweis auf den Spam-Ordner ist keine Floskel: die Testmail
                vom 04.09.2026 landete trotz spf=pass, dkim=pass und dmarc=pass
                im Junk. Ohne den Satz sieht eine Lehrkraft eine Bestätigung,
                findet keine Mail und ruft an - der Bildschirm behauptet dann
                etwas, das der Posteingang nicht bestätigt. */}
            <br />
            Keine E-Mail im Postfach? Sehen Sie bitte auch im Spam-Ordner nach.
          </div>
        ) : (
          <form onSubmit={submit}>
            {status.kind === "error" && (
              <div className={`${styles.notice} ${styles.noticeError}`}>
                Anmeldung nicht möglich: {status.text}
                <br />
                Konten werden von der Schule eingerichtet – wenn Sie noch keines haben,
                wenden Sie sich an Ihre Schulleitung.
              </div>
            )}
            <label htmlFor="email">Ihre dienstliche E-Mail-Adresse</label>
            <input
              id="email"
              className={`${styles.field} ${styles.spaced}`}
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@schule.de"
            />
            <div className={`${styles.row} ${styles.spaced}`}>
              <button type="submit" className={styles.button} disabled={blocked}>
                {status.kind === "sending" ? "Wird gesendet …" : "Anmeldelink senden"}
              </button>
            </div>
            {/* Kein Passwortfeld: Lehrkräfte melden sich selten an, und ein
                Passwort für dreimal im Jahr landet auf einem Zettel am Monitor. */}
            <p
              className={`${styles.subtitle} ${styles.spaced}`}
              style={{ marginBottom: 0 }}
            >
              Sie erhalten einen Link per E-Mail – kein Passwort nötig.
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
